import type { DashboardUseCase } from "../../types/use-case.types"

export const COLUMNS: { key: string; label: string; alwaysVisible?: boolean }[] = [
  { key: "votes", label: "Votes" },
  { key: "ucName", label: "Use Case", alwaysVisible: true },
  { key: "sites", label: "Site" },
  { key: "efSel", label: "Function" },
  { key: "statusText", label: "Status" },
  { key: "tenkCategory", label: "10K Rule" },
  { key: "investment", label: "Investment" },
  { key: "opCostYearly", label: "Op. Cost" },
  { key: "totalCapacityHours", label: "Hours" },
  { key: "annualBenefit", label: "Annual Benefit" },
  { key: "roi12m", label: "ROI" },
  { key: "bpSel", label: "Business Pain" },
  { key: "feasV", label: "Feasibility" },
  { key: "qaScore", label: "QA Score" },
]

export type SortKey =
  | "ucName"
  | "sites"
  | "efSel"
  | "statusText"
  | "tenkCategory"
  | "investment"
  | "opCostYearly"
  | "totalCapacityHours"
  | "annualBenefit"
  | "roi12m"
  | "bpSel"
  | "feasV"
  | "qaScore"
  | "votes"

export const statusBadgeVariant = (status: string) => {
  switch (status) {
    case "Implemented":
      return "success"
    case "In Progress":
      return "warning"
    case "On Hold":
      return "error"
    default:
      return "secondary"
  }
}

export const feasBadgeVariant = (feasV: string) => {
  switch (feasV) {
    case "3":
      return "success"
    case "2":
      return "warning"
    case "1":
      return "error"
    default:
      return "secondary"
  }
}

export const tenkBadgeVariant = (category: string) => {
  switch (category) {
    case "Realistic":
      return "success"
    case "Ambitious":
      return "warning"
    case "Minimal":
      return "secondary"
    case "Low success rate":
      return "error"
    default:
      return "secondary"
  }
}

export function getSortValue(uc: DashboardUseCase, key: SortKey): string | number {
  switch (key) {
    case "ucName":
      return uc.ucName.toLowerCase()
    case "sites":
      return uc.sites.join(", ").toLowerCase()
    case "efSel":
      return uc.efSel.join(", ").toLowerCase()
    case "statusText":
      return uc.statusText
    case "tenkCategory":
      return uc.tenkCategory
    case "investment":
      return parseFloat(uc.investment) || 0
    case "opCostYearly":
      return uc.opCostYearly
    case "totalCapacityHours":
      return uc.totalCapacityHours
    case "annualBenefit":
      return uc.annualBenefit
    case "roi12m":
      return uc.roi12m
    case "bpSel":
      return uc.bpSel.join(", ").toLowerCase()
    case "feasV":
      return uc.feasV
    case "qaScore":
      return uc.qaScore ?? -1
    case "votes":
      return uc.voteCount ?? 0
    default:
      return 0
  }
}
